import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "assignment-update"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("任务管理");

const _hoisted_3 = {
  key: 0
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择会议");

const _hoisted_5 = {
  class: "tips"
};
const _hoisted_6 = {
  key: 0,
  class: "imgs"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("图文教程");

const _hoisted_8 = {
  key: 0,
  class: "imgs"
};
const _hoisted_9 = {
  key: 1
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("视频教程");

const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "视频链接", -1);

const _hoisted_12 = /*#__PURE__*/_createTextVNode("时间段");

const _hoisted_13 = {
  key: 2,
  class: "tips"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("无");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("自定义奖励");

const _hoisted_16 = /*#__PURE__*/_createTextVNode("选择课程");

const _hoisted_17 = {
  class: "tips"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode("选择课程试卷");

const _hoisted_19 = {
  class: "tips"
};
const _hoisted_20 = {
  key: 0,
  class: "tips"
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode("选择团队");

const _hoisted_22 = {
  class: "tips"
};
const _hoisted_23 = {
  class: "search"
};

const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "成员姓名", -1);

const _hoisted_25 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_26 = {
  class: "toolbox"
};

const _hoisted_27 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_28 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  class: "tips"
}, "默认不包含团队负责人，若需添加请新增", -1);

const _hoisted_30 = /*#__PURE__*/_createTextVNode("发布");

const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  "w-full": "",
  src: "https://wyc-fe-static.yun-sk.com/static/wyt/assign-guide.png",
  style: {
    "width": "100%"
  }
}, null, -1);

const _hoisted_32 = ["src"];
import { ref, reactive, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { get } from 'lodash-es';
import { taskPublish, taskNoJoinUser, taskDetail } from '@/request';
import { ElMessage } from 'element-plus';
import MemberModal from './member-modal.vue';
import SuplierModal from './suplier-modal.vue';
import MeetingModal from './meeting-modal.vue';
import CourseModal from './course-modal.vue';
import PaperModal from './paper-modal.vue';
export default {
  name: 'update',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    onMounted(() => {
      let {
        taskId
      } = route.query;
      if (taskId) getDetail();
    });
    const editDisabled = computed(() => {
      return route.query.taskId;
    });
    const form = ref();

    function onTaskTypeChange() {
      formData.dateRange = [];
      formData.trainingCourseId = null;
      formData.trainingCourseName = '';
      formData.trainingPaperId = null;
      formData.trainingPaperName = '';
      selectedMeetingInfo.value = {};
    }

    const formData = reactive({
      taskType: 1,
      taskName: '',
      timeType: 1,
      dateRange: [],
      custNum: null,
      courseType: 1,
      rewardType: 0,
      rewardDesc: '',
      teamList: [],
      userList: [],
      sampleImage: [],
      courseImage: [],
      courseVideo: '',
      trainingCourseId: null,
      trainingCourseName: '',
      trainingPaperId: null,
      trainingPaperName: ''
    });
    const formRules = {
      taskName: {
        required: true,
        message: '请填写任务名称'
      },
      dateRange: {
        required: true,
        message: '请选择任务时间'
      },
      custNum: {
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.taskType == 4 || formData.taskType == 5) {
            callback();
            return;
          }

          if (!formData.custNum) {
            callback(new Error('请选择客户数'));
            return;
          }

          callback();
        }
      },
      trainingCourseId: {
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.taskType == 4 && !formData.trainingCourseId) {
            callback(new Error('请选择培训课程'));
            return;
          }

          callback();
        }
      },
      trainingPaperId: {
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.taskType == 5 && !formData.trainingPaperId) return callback(new Error('请选择培训试卷'));
          callback();
        }
      },
      rewardType: {
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.rewardType == 1 && !formData.rewardDesc) {
            callback(new Error('请填写奖励'));
            return;
          }

          callback();
        }
      },
      userList: {
        required: true,
        message: '请选择成员'
      },
      sampleImage: {
        required: true,
        message: '请上传图片'
      },
      courseType: {
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.courseType == 1 && formData.courseImage.length == 0) {
            callback(new Error('请上传图片'));
            return;
          }

          if (formData.courseType == 2 && !formData.courseVideo) {
            callback(new Error('请填写链接'));
            return;
          }

          callback();
        }
      }
    };
    const detail = ref({});
    const loading = ref(false);

    function getDetail() {
      loading.value = true;
      taskDetail({
        taskId: route.query.taskId
      }).then(res => {
        let {
          success,
          data
        } = res;
        if (!success) return;
        detail.value = data;
        formData.taskType = data.taskType;
        formData.taskName = data.taskName;
        formData.timeType = data.timeType;
        formData.custNum = data.custNum;
        formData.rewardType = data.rewardType;
        formData.rewardDesc = data.rewardDesc;
        formData.sampleImage = data.sampleImage && get(data, 'sampleImage', '').split(',').map(url => ({
          url
        }));

        if (data.courseImage) {
          formData.courseImage = get(data, 'courseImage', '').split(',').map(url => ({
            url
          }));
        }

        formData.courseVideo = data.courseVideo;
        formData.courseType = data.courseType;
        formData.trainingCourseId = data.trainingCourseId;
        formData.trainingCourseName = data.trainingCourseName;
        formData.trainingPaperId = data.trainingPaperId;
        formData.trainingPaperName = data.trainingPaperName;

        if (data.timeType == 1) {
          formData.dateRange = [data.startTime, data.endTime];
        }

        formData.userList = data.taskUserList;
        formData.teamList = JSON.parse(data.teamJson);
        renderMemberList();
      }).finally(() => loading.value = false);
    }

    const memberUserList = ref([]);
    const guidePreviewShow = ref(false);
    const memberModal = reactive({
      show: false,
      params: {},
      selectedIds: []
    });

    function addMemberModal() {
      memberModal.show = true;
      memberModal.params = {
        taskId: formData.taskId,
        teamJson: JSON.stringify(formData.teamList),
        containOwner: 1
      };
      memberModal.selectedIds = formData.userList.map(v => v.supUserId);
    }

    function addMemberConfirm(memberList) {
      formData.userList = [...memberList, ...formData.userList];
      renderMemberList();
    }

    const supplierModal = reactive({
      show: false
    });
    const suppliersName = computed(() => {
      let teamList = formData.teamList;
      if (teamList.length == 0) return;
      let str = '';
      let levelTypeList = ['0', '1', '2'];
      levelTypeList.forEach(levelType => {
        str += teamList.filter(v => v.levelType == levelType).map(v => v.text).join();

        if (levelType != '2') {
          str += '__';
        }
      });
      return str;
    });
    const defauleCheckedSupplierId = computed(() => {
      return formData.teamList.map(v => v.id);
    });

    function selectSupplierModal() {
      if (formData.taskType == 3 && !selectedMeetingInfo.value.scienceId) {
        ElMessage.warning('请先选择会议');
        return;
      }

      supplierModal.show = true;
    }

    function getSelectedSupplier(e) {
      if (e.length == 0) return;
      formData.teamList = e.map(item => {
        let obj = {};
        let idList = item.id.split('-');

        if (idList.length > 1) {
          obj.teamId = idList[0];
          obj.structureId = idList[1];
        } else {
          obj.teamId = idList[0];
        }

        obj.text = item.text;
        obj.levelType = item.levelType;
        obj.id = item.id;
        return obj;
      });
      console.log(formData.teamList);
      let teamList = formData.teamList.map(item => ({
        teamId: item.teamId,
        structureId: item.structureId
      }));
      let params = {
        teamJson: JSON.stringify(teamList),
        page: 1,
        pageSize: 3000,
        containOwner: 0
      };
      taskNoJoinUser(params).then(res => {
        if (!res.success) return;
        formData.userList = res.data;
        memberUserList.value = res.data;
      });
    }

    const userSearchKey = ref('');

    function renderMemberList() {
      memberUserList.value = formData.userList.filter(item => {
        return item.linkMan.includes(userSearchKey.value);
      });
    }

    const selectedMemberList = ref([]);

    function memberTableDeleteHandle() {
      let currentMemberList = [...formData.userList];
      formData.userList = currentMemberList.filter(item => {
        return Boolean(selectedMemberList.value.find(v => v.supUserId == item.supUserId)) === false;
      });
      userSearchKey.value = '';
      renderMemberList();
      ElMessage.success('删除成功');
    } // 关联会议


    const meetingShow = ref(false);
    const selectedMeetingInfo = ref({});

    function selectMeetingHandle(info) {
      if (selectedMeetingInfo.value.scienceId == info.scienceId) return;
      selectedMeetingInfo.value = info;
      formData.taskName = info.scienceName;
      formData.dateRange = [info.proStartTime, info.proEndTime];
      formData.teamList = [];
      formData.userList = [];
      memberUserList.value = [];
    }

    const courseModalShow = ref(false);

    function selectCourseHandle(info) {
      formData.trainingCourseId = info.courseId;
      formData.trainingCourseName = info.title;

      if (!formData.taskName) {
        formData.taskName = info.title;
      }
    }

    const paperModalShow = ref(false);

    function selectPaperHandle(info) {
      formData.trainingPaperId = info.paperId;
      formData.trainingPaperName = info.title;
      formData.trainingCourseId = info.courseId;
      formData.trainingCourseName = info.courseTitle;
      if (!formData.taskName) formData.taskName = info.title;
    }

    const previewModal = ref({
      show: false,
      url: ''
    });

    function previewImage(image) {
      console.log(image);
      previewModal.value = {
        show: true,
        url: decodeURIComponent(get(image, 'url'))
      };
    }

    function submit() {
      form.value.validate(e => {
        if (!e) return;
        let body = {
          taskType: formData.taskType,
          taskName: formData.taskName,
          timeType: formData.timeType,
          custNum: formData.custNum,
          rewardType: formData.rewardType,
          teamJson: JSON.stringify(formData.teamList),
          userList: formData.userList.map(v => v.supUserId).join() // [333,333,33]

        };

        if (formData.taskType == 2) {
          body.sampleImage = formData.sampleImage.map(v => {
            if (v.url.includes('blob')) {
              return decodeURIComponent(get(v, 'response.data.picUrl'));
            }

            return v.url;
          }).join();
          body.courseType = formData.courseType;

          if (formData.courseType == 1) {
            body.courseImage = formData.courseImage.map(v => {
              if (v.url.includes('blob')) {
                return decodeURIComponent(get(v, 'response.data.picUrl'));
              }

              return v.url;
            }).join();
          } else {
            body.courseVideo = formData.courseVideo;
          }
        }

        if (formData.timeType == 1) {
          if (!editDisabled.value && !formData.dateRange[0].includes(':')) {
            body.startTime = formData.dateRange[0] + ' 00:00:00';
            body.endTime = formData.dateRange[1] + ' 23:59:59';
          } else {
            body.startTime = formData.dateRange[0];
            body.endTime = formData.dateRange[1];
          }
        }

        if (formData.taskType == 3) {
          // console.log(selectedMeetingInfo.value)
          body.bizId = selectedMeetingInfo.value.scienceId;
        }

        if (formData.taskType == 4 || formData.taskType == 5) {
          body.trainingCourseId = formData.trainingCourseId;
          body.trainingCourseName = formData.trainingCourseName;
          body.custNum = formData.custNum || 0;
        }

        if (formData.taskType == 5) {
          body.trainingPaperId = formData.trainingPaperId;
          body.trainingPaperName = formData.trainingPaperName;
        }

        if (formData.rewardType == 1) {
          body.rewardDesc = formData.rewardDesc;
        }

        let taskId = route.query.taskId;
        taskId && (body.taskId = taskId);
        taskPublish(body).then(res => {
          let {
            success,
            msg
          } = res;

          if (success) {
            ElMessage.success('操作成功');
            router.go(-1);
          } else {
            ElMessage.error(msg);
          }
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");

      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_image = _resolveComponent("el-image");

      const _component_Plus = _resolveComponent("Plus");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_card = _resolveComponent("el-card");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: {
              name: 'assignment'
            }
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(detail.value.taskName || '新建任务'), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form, {
        ref_key: "form",
        ref: form,
        model: formData,
        rules: formRules,
        "label-position": "right",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "任务类型",
          prop: "taskType",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: formData.taskType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.taskType = $event),
            style: {
              "width": "200px"
            },
            disabled: _unref(editDisabled),
            onChange: onTaskTypeChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "拜访任务",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "陈列任务",
              value: 2
            }), _createVNode(_component_el_option, {
              label: "会议邀约任务",
              value: 3
            }), _createVNode(_component_el_option, {
              label: "培训学习",
              value: 4
            }), _createVNode(_component_el_option, {
              label: "培训考试",
              value: 5
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "任务名称",
          prop: "taskName"
        }, {
          default: _withCtx(() => [formData.taskType == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = $event => meetingShow.value = true),
            disabled: _unref(editDisabled)
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          }, 8, ["disabled"]), _createElementVNode("span", _hoisted_5, _toDisplayString(selectedMeetingInfo.value.scienceName || detail.value.taskName), 1)])) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            modelValue: formData.taskName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.taskName = $event),
            placeholder: "请输入任务名称",
            style: {
              "width": "500px"
            },
            maxLength: "20",
            disabled: _unref(editDisabled)
          }, null, 8, ["modelValue", "disabled"]))]),
          _: 1
        }), formData.taskType == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_form_item, {
          label: "陈列展示效果图",
          prop: "sampleImage"
        }, {
          default: _withCtx(() => [_unref(editDisabled) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.sampleImage, (item, index) => {
            return _openBlock(), _createBlock(_component_el_image, {
              src: item.url,
              key: index,
              "initial-index": index,
              previewSrcList: formData.sampleImage.map(v => v.url)
            }, null, 8, ["src", "initial-index", "previewSrcList"]);
          }), 128))])) : (_openBlock(), _createBlock(_component_el_upload, {
            key: 1,
            "list-type": "picture-card",
            action: "/basic/uploadFile.json",
            "file-list": formData.sampleImage,
            "onUpdate:file-list": _cache[3] || (_cache[3] = $event => formData.sampleImage = $event),
            accept: "images/jpg,image/png,image/jpeg",
            limit: 10,
            class: _normalizeClass({
              limitupload: formData.sampleImage.length == 9
            }),
            "on-preview": previewImage
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_Plus)]),
              _: 1
            })]),
            _: 1
          }, 8, ["file-list", "class"]))]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "陈列教程",
          class: "block no-input-red",
          prop: "courseType"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: formData.courseType,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.courseType = $event),
            class: "block-radio-group",
            disabled: _unref(editDisabled)
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            }), _unref(editDisabled) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.courseImage, (item, index) => {
              return _openBlock(), _createBlock(_component_el_image, {
                src: item.url,
                key: index,
                "initial-index": index,
                previewSrcList: formData.courseImage.map(v => v.url)
              }, null, 8, ["src", "initial-index", "previewSrcList"]);
            }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_upload, {
              "list-type": "picture-card",
              action: "/basic/uploadFile.json",
              "file-list": formData.courseImage,
              "onUpdate:file-list": _cache[4] || (_cache[4] = $event => formData.courseImage = $event),
              accept: "images/jpg,image/png,image/jpeg",
              limit: 10,
              class: _normalizeClass({
                limitupload: formData.courseImage.length == 9
              }),
              "on-preview": previewImage
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Plus)]),
                _: 1
              })]),
              _: 1
            }, 8, ["file-list", "class"])]))]), _createElementVNode("div", null, [_createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_10]),
              _: 1
            }), _createElementVNode("div", null, [_hoisted_11, _createVNode(_component_el_input, {
              modelValue: formData.courseVideo,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.courseVideo = $event),
              placeholder: "上传抖音/快手视频链接",
              style: {
                "width": "200px",
                "margin": "0 10px"
              },
              disabled: _unref(editDisabled)
            }, null, 8, ["modelValue", "disabled"]), _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[6] || (_cache[6] = $event => guidePreviewShow.value = true),
              style: {
                "color": "#4093ff"
              }
            }, "获取链接教程指导")])])]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "任务时间",
          class: "block",
          prop: "dateRange"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: formData.timeType,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.timeType = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_12]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _createElementVNode("div", null, [formData.taskType == 3 ? (_openBlock(), _createBlock(_component_el_date_picker, {
            key: 0,
            modelValue: formData.dateRange,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.dateRange = $event),
            type: "datetimerange",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            style: {
              "width": "400px"
            },
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间",
            "unlink-panels": "",
            disabled: _unref(editDisabled),
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)]
          }, null, 8, ["modelValue", "disabled", "default-time"])) : (_openBlock(), _createBlock(_component_el_date_picker, {
            key: 1,
            modelValue: formData.dateRange,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formData.dateRange = $event),
            type: "daterange",
            "value-format": "YYYY-MM-DD",
            style: {
              "width": "400px"
            },
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间",
            "unlink-panels": "",
            disabled: _unref(editDisabled),
            disabledDate: date => Date.now() > date.getTime() + 24 * 60 * 60 * 1000
          }, null, 8, ["modelValue", "disabled", "disabledDate"])), formData.taskType == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_13, "任务时间默认与会议推广时间一致")) : _createCommentVNode("", true)])]),
          _: 1
        }), formData.taskType != 4 && formData.taskType != 5 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "任务客户数",
          prop: "custNum"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: formData.custNum,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formData.custNum = $event),
            "controls-position": "right",
            min: 1,
            max: 99999,
            disabled: _unref(editDisabled)
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "任务奖励",
          prop: "rewardType"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: formData.rewardType,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formData.rewardType = $event),
            class: "block-radio-group",
            disabled: _unref(editDisabled)
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_radio, {
              label: 0
            }, {
              default: _withCtx(() => [_hoisted_14]),
              _: 1
            })]), _createElementVNode("div", null, [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_15]),
              _: 1
            }), _createElementVNode("div", null, [_createVNode(_component_el_input, {
              modelValue: formData.rewardDesc,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formData.rewardDesc = $event),
              type: "textarea",
              placeholder: "请输入自定义奖励，可描述奖励内容、奖励方式、奖励时间等",
              style: {
                "width": "500px"
              },
              maxLength: "100",
              disabled: _unref(editDisabled)
            }, null, 8, ["modelValue", "disabled"])])])]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        }), formData.taskType == 4 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 2,
          label: "培训课程",
          class: "block no-input-red",
          prop: "trainingCourseId"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[14] || (_cache[14] = $event => courseModalShow.value = true),
            disabled: _unref(editDisabled)
          }, {
            default: _withCtx(() => [_hoisted_16]),
            _: 1
          }, 8, ["disabled"]), _createElementVNode("span", _hoisted_17, _toDisplayString(formData.trainingCourseName || detail.value.trainingCourseName), 1)])]),
          _: 1
        })) : _createCommentVNode("", true), formData.taskType == 5 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 3,
          label: "培训试卷",
          class: "block no-input-red",
          prop: "trainingPaperId"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[15] || (_cache[15] = $event => paperModalShow.value = true),
            disabled: _unref(editDisabled)
          }, {
            default: _withCtx(() => [_hoisted_18]),
            _: 1
          }, 8, ["disabled"]), _createElementVNode("span", _hoisted_19, _toDisplayString(formData.trainingPaperName || detail.value.trainingPaperName), 1), formData.trainingCourseName || detail.value.trainingCourseName ? (_openBlock(), _createElementBlock("div", _hoisted_20, "所属课程：" + _toDisplayString(formData.trainingCourseName || detail.value.trainingCourseName), 1)) : _createCommentVNode("", true)])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: `选择业务成员(${formData.userList.length}人)`,
          class: "block no-input-red",
          prop: "userList"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: selectSupplierModal,
            disabled: _unref(editDisabled)
          }, {
            default: _withCtx(() => [_hoisted_21]),
            _: 1
          }, 8, ["disabled"]), _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(suppliersName)), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_card, {
            shadow: "never",
            class: "membership"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createVNode(_component_el_input, {
              modelValue: userSearchKey.value,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => userSearchKey.value = $event),
              placeholder: "请输入成员姓名",
              style: {
                "width": "200px",
                "margin-right": "10px"
              }
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              onClick: renderMemberList
            }, {
              default: _withCtx(() => [_hoisted_25]),
              _: 1
            })]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_button, {
              type: "danger",
              disabled: !selectedMemberList.value.length,
              onClick: memberTableDeleteHandle
            }, {
              default: _withCtx(() => [_hoisted_27]),
              _: 1
            }, 8, ["disabled"]), _createVNode(_component_el_button, {
              type: "primary",
              disabled: !formData.teamList.length,
              onClick: addMemberModal
            }, {
              default: _withCtx(() => [_hoisted_28]),
              _: 1
            }, 8, ["disabled"]), _hoisted_29]), _createVNode(_component_el_table, {
              data: memberUserList.value,
              maxHeight: "600px",
              onSelectionChange: _cache[17] || (_cache[17] = list => selectedMemberList.value = list)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "操作",
                type: "selection",
                width: "55"
              }), _createVNode(_component_el_table_column, {
                label: "团队成员",
                prop: "linkMan"
              }), _createVNode(_component_el_table_column, {
                label: "所属团队",
                prop: "supplierName"
              }), _createVNode(_component_el_table_column, {
                label: "角色名称",
                prop: "employeeName"
              })]),
              _: 1
            }, 8, ["data"])]),
            _: 1
          })])]),
          _: 1
        }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            style: {
              "width": "200px"
            },
            onClick: submit
          }, {
            default: _withCtx(() => [_hoisted_30]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(MemberModal, {
        params: memberModal.params,
        selectedIds: memberModal.selectedIds,
        modelValue: memberModal.show,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => memberModal.show = $event),
        onSuccess: addMemberConfirm
      }, null, 8, ["params", "selectedIds", "modelValue"]), _createVNode(SuplierModal, {
        modelValue: supplierModal.show,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => supplierModal.show = $event),
        defaultChecked: _unref(defauleCheckedSupplierId),
        taskType: formData.taskType,
        scienceId: selectedMeetingInfo.value.scienceId,
        onSuccess: getSelectedSupplier
      }, null, 8, ["modelValue", "defaultChecked", "taskType", "scienceId"]), _createVNode(MeetingModal, {
        modelValue: meetingShow.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => meetingShow.value = $event),
        onSuccess: selectMeetingHandle
      }, null, 8, ["modelValue"]), _createVNode(CourseModal, {
        modelValue: courseModalShow.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => courseModalShow.value = $event),
        onSuccess: selectCourseHandle
      }, null, 8, ["modelValue"]), _createVNode(PaperModal, {
        modelValue: paperModalShow.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => paperModalShow.value = $event),
        onSuccess: selectPaperHandle
      }, null, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: guidePreviewShow.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => guidePreviewShow.value = $event),
        width: "90%",
        top: "50px"
      }, {
        default: _withCtx(() => [_hoisted_31]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: previewModal.value.show,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => previewModal.value.show = $event),
        width: "90%",
        top: "50px"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          "w-full": "",
          src: previewModal.value.url,
          style: {
            "width": "100%"
          }
        }, null, 8, _hoisted_32)]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }

};